import React from 'react';

/**
 * VenueImage - Mekan fotoğrafı bileşeni
 * Tüm mekanlar için normal fotoğraf gösterir
 */
const VenueImage = ({ 
  src, 
  alt, 
  isClaimed = false, 
  venueSlug,
  className = '',
  imgClassName = '',
  showClaimBadge = false,
  onClick
}) => {
  return (
    <div className={`relative overflow-hidden ${className}`}>
      {/* Fotoğraf - Tüm mekanlarda normal gösterilir */}
      <img
        src={src || '/placeholder-venue.jpg'}
        alt={alt || 'Mekan'}
        className={`w-full h-full object-cover transition-all duration-300 ${imgClassName}`}
        onClick={onClick}
      />
    </div>
  );
};

export default VenueImage;
